import * as React from 'react';
import { EServiceId } from '../../../../../../../../../../types/reducers/publishTerms';
import * as styles from './Service.container.css';
import { useService } from './hooks';
import { serviceIdMapToComponent } from './serviceIdMapToComponent';
import { getServiceText } from './utils/getServiceText';
import { useSelector } from 'react-redux';
import { selectExperiments } from '../../../../../../../../../../selectors/experiments';
import { allExperiments } from '../../../../../../../../../../constants/experiments';

export interface IServiceContainerProps {
  serviceId: EServiceId;
}

export const ServiceContainer = ({ serviceId }: IServiceContainerProps) => {
  const experiments = useSelector(selectExperiments);
  const { formattedPrice, price, onClick, isSelected, isVisible } = useService(serviceId);

  if (!isVisible) {
    return null;
  }

  const Service = serviceIdMapToComponent[serviceId];
  const { subtitle, title, description } = getServiceText(serviceId, experiments, allExperiments);

  return (
    <div className={styles['service-container']}>
      <Service
        title={title}
        subtitle={subtitle}
        description={description}
        price={price}
        serviceId={serviceId}
        isSelected={isSelected}
        formattedPrice={formattedPrice}
        onClick={onClick}
      />
    </div>
  );
};
